module.exports = __webpack_public_path__ + "img/tile-keyframes_en.4bf997b.jpg";